import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './Verify.module.css';
import Logo from 'assets/images/logos/logo-dark-backgrounds.svg';
import Button from 'components/UI/Button/Button';
import Dialogue from 'components/UI/Dialogue/Dialogue';
import { updateObject } from 'shared/utility';
import * as actions from 'store/actions';

class Verify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      codeFields: {
        field1: '',
        field2: '',
        field3: '',
        field4: '',
        field5: '',
        field6: '',
      },
      formIsValid: false,
      codeSentTo: '',
      showCodeSentDialogue: false,
      showCancelAccountConfirmationDialogue: false,
    };
  }

  componentDidMount() {
    // If user has created account from their existing browser and hasn't deleted their cookies, a codeSentTo object will be stored.
    // We'll save codeSentTo to State to determine whether the code was sent via email or text.
    if (localStorage.getItem('codeSentTo')) {
      this.setState({ codeSentTo: localStorage.getItem('codeSentTo').replace(/['"]+/g, '') });
    } else if (this.props.CodeSentTo) {
      this.setState({ codeSentTo: this.props.CodeSentTo });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.CodeSentTo && !prevProps.CodeSentTo && !this.state.CodeSentTo)
      this.setState({ codeSentTo: this.props.CodeSentTo.replace(/['"]+/g, '') });
    if (!prevProps.verificationCodeResent && this.props.verificationCodeResent) this.setState({ showCodeSentDialogue: true });

    // After successful verification
    if (this.props.accountVerified && !prevProps.accountVerified && !this.props.isAccountManagement) {
      // Once new user verifies their account's email address, take them to add mobile screen
      if (this.props.CodeSentTo === 'Email') {
        this.props.history.push('/add-mobile');
      }

      // If a new user just verified their phone number take them to the /create-profile screen
      if (this.props.CodeSentTo === 'Phone' && !this.props.isAccountManagement) {
        if (this.props.signedInAs.ProfileStatus === 'NotComplete') {
          this.props.history.push('/create-profile');
        } else {
          this.props.history.push('/my-riza');
        }
      }
    }
  }

  handleInputFieldChange = (e) => {
    const { maxLength, value, name } = e.target;
    const fieldIndex = name.split('-')[1];

    // Check if they hit the max character length,
    // if not, advance user to next form field
    if (value.length >= maxLength) {
      // Check if it's not the last input field
      if (parseInt(fieldIndex, 10) < Object.keys(this.state.codeFields).length) {
        // Get the next input field
        const nextSibling = document.querySelector(`input[name=code-${parseInt(fieldIndex, 10) + 1}]`);

        // If found, focus the next field
        if (nextSibling !== null) {
          nextSibling.focus();
        }
      }
    }
    // Update state with form field input.
    const updatedCodeFields = updateObject(this.state.codeFields, {
      [`field${fieldIndex}`]: value,
    });
    const allFieldsEntered = Object.values(updatedCodeFields).filter((val) => val === '').length === 0;
    this.setState({ codeFields: updatedCodeFields, formIsValid: allFieldsEntered });
  };

  handleVerificationCodeSubmit = () => {
    // If all fields are filled, submit verification code
    if (this.state.formIsValid) {
      const verificationCode = Object.values(this.state.codeFields).join('');
      if (this.props.UserId) this.props.onVerifyAccount(this.props.UserId, verificationCode);
    }
  };

  resendVerificationCode = () => {
    const verify = this.state.codeSentTo === 'Email' || !this.state.codeSentTo ? 'Email' : 'Phone';
    this.props.onResendAccountVerificationCode(this.props.UserId, verify);
  };

  handleCancelVerificationProcess = () => {
    localStorage.removeItem('signedInAs');
    localStorage.removeItem('postingAs');
    localStorage.removeItem('codeSentTo');
    this.setState({ showCancelAccountConfirmationDialogue: false });
    this.props.onResetAuthData();
    this.props.history.push('/sign-up');
  };

  handleSkipPhoneValidation = () => {
    this.props.history.push('/create-profile');
  };

  render = () => {
    const verifyContainerClasses = [classes.VerifyContainer];
    if (this.props.isAccountManagement) verifyContainerClasses.push(classes.ManageAccount);
    let dialogue = null;
    const codeDigitsArray = Array.from(Array(Object.keys(this.state.codeFields).length), (_, index) => index + 1);
    const verificationCodeFields = codeDigitsArray.map((index) => (
      <input
        type="text"
        key={`field-${index}`}
        maxLength={1}
        value={this.state.codeFields[index]}
        onChange={(e) => this.handleInputFieldChange(e)}
        name={`code-${index}`}
        className={classes.VerificationField}
      />
    ));

    let errorMessage = null;
    if (this.props.error) {
      errorMessage = (
        <p id="authError" className={classes.ErrorMessage}>
          {this.props.error.replace(/_/g, ' ')}
        </p>
      );
    }

    if (this.state.showCodeSentDialogue) {
      dialogue = (
        <Dialogue
          whiteBackground
          className="Verify"
          subject="New Code Sent"
          message="A new code has been sent to your email."
          confirm={() => this.setState({ showCodeSentDialogue: false })}
          confirmationText="OK"
        />
      );
    } else if (this.state.showCancelAccountConfirmationDialogue) {
      dialogue = (
        <Dialogue
          whiteBackground
          className="Verify"
          subject="Cancel Account Creation"
          message="Are you sure you want to cancel the sign up process?"
          cancelled={() => this.setState({ showCancelAccountConfirmationDialogue: false })}
          cancelText="No, continue signing up"
          confirm={this.handleCancelVerificationProcess}
          confirmationText="Yes"
        />
      );
    }

    const validationActions = (
      <div>
        {this.props.isAccountManagement ? (
          <div>
            <FontAwesomeIcon icon="mobile-alt" className={classes.MobilePhone} />
            <h2 className={classes.Title}>Verify Phone</h2>
            <h2 className={classes.Directions}>Enter 6 digit code from the text message sent to your phone.</h2>
          </div>
        ) : this.state.codeSentTo === 'Email' ? (
          <h2 className={classes.Directions}>
            <FontAwesomeIcon icon={['far', 'envelope']} className={classes.Envelope} />
            Enter 6 digit code from the message sent to your email.
          </h2>
        ) : (
          <h2 className={classes.Directions}>
            <FontAwesomeIcon icon="mobile-alt" className={classes.MobilePhone} />
            Enter 6 digit code from the text message sent to your phone.
          </h2>
        )}
        {errorMessage}
        <div className={classes.VerificationFields}>{verificationCodeFields}</div>
        <div>
          <p onClick={this.resendVerificationCode} className={classes.ResendCode}>
            Resend Code
          </p>
          <Button btnType="Verify" clicked={this.handleVerificationCodeSubmit} disabled={!this.state.formIsValid}>
            {this.state.codeSentTo === 'Email' ? 'Verify Email and Create Account' : 'Verify Phone'}
          </Button>
          {this.props.isAccountManagement ? null : this.state.codeSentTo === 'Email' ? (
            <p onClick={() => this.setState({ showCancelAccountConfirmationDialogue: true })} className={classes.CancelProcess}>
              Cancel new account
            </p>
          ) : (
            <p onClick={this.handleSkipPhoneValidation} className={classes.Skip}>
              Skip this for now and enter Riza
            </p>
          )}
        </div>
      </div>
    );
    return (
      <div className={verifyContainerClasses.join(' ')}>
        <div className={classes.RizaLogo}>
          <img src={Logo} alt="riza" />
        </div>
        {dialogue}
        {validationActions}
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    UserId: state.auth.UserId,
    CodeSentTo: state.auth.CodeSentTo,
    verificationCodeResent: state.auth.verificationCodeResent,
    error: state.auth.error,
    signedInAs: state.user.signedInAs,
    accountVerified: state.auth.accountVerified,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onVerifyAccount: (UserId, Code) => dispatch(actions.verifyAccount(UserId, Code)),
    onResendAccountVerificationCode: (UserId, Ver) => dispatch(actions.resendAccountVerificationCode(UserId, Ver)),
    onResetAuthData: () => dispatch(actions.resetAuthData()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Verify);
